import Auth from '../auth/Auth';
import PaymentInfo from '../models/PaymentInfo';
import { WebClient } from './WebClient'

class ApiPaymentInfo extends WebClient {
    async getPaymentInfo(customerId: number): Promise<PaymentInfo | null> {
        const url = `/billing/info/${customerId}`;

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data;
            }
            return null;
        }).catch(() => { return null; });
    }

    async refundPayment(paymentId: number): Promise<boolean> {
        const url = `/billing/refund/${paymentId}`;

        return this.get(url, Auth.getAuthToken()).then(res => {
            return (res.status === 200);
        }).catch(() => { return false; });
    }

    async processPayments(customerId: number): Promise<boolean> {
        const url = `/billing/processpayments/${customerId}`;

        return this.get(url, Auth.getAuthToken()).then(res => {
            return (res.status === 200);
        }).catch(() => { return false; });
    }

    async processCharge(customerId: number, amount: number, description: string): Promise<boolean> {
        const url = `/billing/addcharge`;
        const data = {
            customerId,
            amount,
            description
        };
        return this.post(url, data, Auth.getAuthToken()).then(res => {
            return (res.status === 200);
        }).catch(() => { return false; });
    }

    async processCredit(customerId: number, amount: number, description: string): Promise<boolean> {
        const url = `/billing/addcredit`;
        const data = {
            customerId,
            amount,
            description
        };
        return this.post(url, data, Auth.getAuthToken()).then(res => {
            return (res.status === 200);
        }).catch(() => { return false; });
    }
}

export default new ApiPaymentInfo();
